export default __webpack_public_path__ + "static/media/left-arrow.a75a427f.svg";